var _defs, _rect, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSkelpCommInv(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_4",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 105.37 93.56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:none;}.cls-3{clip-path:url(#clippath);}.cls-4{fill:#e9aa21;}.cls-5,.cls-6{fill:#fff;}.cls-2{stroke:#fff;stroke-miterlimit:10;stroke-width:2.03px;}.cls-7,.cls-6{opacity:.65;}.cls-8{opacity:.92;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 52.16,
    cy: 47.13,
    r: 30.48
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 8.82,
    y: 3.86,
    width: 85.85,
    height: 85.85,
    rx: 5.1,
    ry: 5.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "m89.56,5.42c1.95,0,3.54,1.59,3.54,3.54v75.64c0,1.95-1.59,3.54-3.54,3.54H13.92c-1.95,0-3.54-1.59-3.54-3.54V8.96c0-1.95,1.59-3.54,3.54-3.54h75.64m0-1.56H13.92c-2.82,0-5.1,2.29-5.1,5.1v75.64c0,2.82,2.29,5.1,5.1,5.1h75.64c2.82,0,5.1-2.29,5.1-5.1V8.96c0-2.82-2.29-5.1-5.1-5.1h0Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m42.12,45.36l.8.87,10.43-9.54c.69-.64,1.78-.59,2.41.11s.58,1.74-.13,2.39l1.73-1.57c-.06-.59-.3-1.16-.73-1.62-1.07-1.18-2.91-1.26-4.08-.18l-10.43,9.54Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m45.2,48.73l.8.87,11.97-10.94c.69-.64,1.78-.59,2.41.11s.59,1.78-.11,2.41l-11.97,10.94.8.87,11.97-10.94c1.18-1.07,1.26-2.91.18-4.08s-2.91-1.26-4.08-.18l-11.97,10.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m37.88,66.71l.8.87,1.38-1.26c.22-.2.53-.3.87-.27,3.77.34,8.34-1.17,10.88-3.57,1.01-.95,2.34-1.67,3.52-2.3,1.69-.9,3.14-1.69,3.4-2.98.22-1.08-.17-1.7-.54-2.04-1.3-1.18-4.03-.39-4.34-.29-.02,0-.05.01-.07.02l8.56-7.83c1.09-1,1.33-2.63.55-3.8-.43-.64-1.08-1.08-1.81-1.23l-1.73,1.58c.37-.34.87-.5,1.37-.45.49.06.91.33,1.2.75.46.69.3,1.66-.36,2.27l-12.63,11.54c-.33.29-.54.49-.6.54l-.03.03.8.87.52-.48c.84-.73,2.59-2.09,4.58-2.7,1.14-.35,2.65-.45,3.2.04.07.07.31.28.18.93-.15.75-1.44,1.44-2.8,2.17-1.24.67-2.65,1.42-3.78,2.49-2.28,2.16-6.56,3.55-9.97,3.25-.67-.06-1.3.14-1.77.57l-1.38,1.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m29.22,57.22l.8.87,1.37-1.25c.47-.43.74-1.07.74-1.75-.01-3.26,1.46-6.4,4.26-9.07l11.03-10.08c.69-.64,1.78-.59,2.41.11s.58,1.74-.13,2.39l1.73-1.58c-.06-.58-.3-1.15-.72-1.61-1.08-1.18-2.91-1.26-4.08-.18l-11.04,10.09c-3.05,2.91-4.65,6.35-4.63,9.94,0,.35-.12.66-.35.87l-1.37,1.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m27.51,57.32c.54-.49,1.37-.45,1.86.08l9.1,9.96c.49.54.45,1.37-.07,1.85l-23.43,23.04-12.5-13.68,25.04-21.25Zm10.12,11.08c.08-.08.09-.21.01-.29l-9.1-9.96c-.08-.08-.2-.09-.3,0l-24.17,20.52,10.94,11.97,22.62-22.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m36.56,44.25c-.19-.98-.28-1.95-.24-2.87.03-.67-.2-1.29-.65-1.74l-1.32-1.32-.84.84,1.32,1.32c.21.21.32.51.31.85-.05,1.24.09,2.55.4,3.85"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m53.44,33.14c-2.45-1.64-5.1-2.42-7.81-2.29-.35.02-.67-.09-.89-.31l-1.31-1.31-.84.84,1.31,1.31c.45.45,1.1.69,1.78.66,2.05-.1,4.08.39,6,1.43,0,0,.42-.05.86.04l.88-.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m43.26,27.53c.51.51.51,1.35,0,1.86l-9.53,9.54c-.51.51-1.35.51-1.85.01L7.8,16.59,20.9,3.48l22.36,24.05Zm-10.61,10.62c.08.08.21.08.29,0l9.53-9.54c.08-.08.08-.21-.01-.3L20.87,5.08l-11.46,11.47,23.25,21.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m53.99,34.21c1.25-.46,2.54-.75,3.76-.81.67-.03,1.27-.32,1.67-.81l1.19-1.44-.91-.75-1.19,1.44c-.19.23-.48.37-.82.38-1.68.08-3.47.55-5.13,1.29.49.1.97.3,1.44.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m69.22,43.28c0-.54-.05-1.08-.12-1.61-.05-.35.03-.67.23-.91l1.18-1.43-.91-.75-1.18,1.43c-.3.37-.48.83-.51,1.33,0,0,.56.89.78,1.22s.54.73.54.73Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m72.19,39c-.46.56-1.3.64-1.86.18l-10.39-8.6c-.56-.46-.64-1.3-.19-1.84L79.75,2.67l14.28,11.81-21.84,24.52Zm-11.57-9.57c-.07.09-.06.22.03.29l10.39,8.6c.09.07.22.06.3-.04l21.09-23.68-12.5-10.34-19.31,25.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m61.94,39.3c.07-.43.22-.83.49-1.15.32-.38.92-.8,2.01-.63,1.3.2,2.15,1.62,3.13,3.26.69,1.15,1.46,2.45,2.46,3.42,2.52,2.43,4.22,6.93,4.06,10.71-.02.34.09.64.31.85l1.32,1.32-.84.84-1.32-1.32c-.45-.45-.68-1.07-.65-1.74.15-3.41-1.44-7.63-3.7-9.81-1.11-1.07-1.93-2.45-2.65-3.66-.79-1.33-1.54-2.58-2.29-2.7-.66-.1-.85.14-.92.22-.47.57-.3,2.07.1,3.2.7,1.96,2.14,3.65,2.9,4.45l.5.5-.84.84-.03-.03c-.06-.05-.27-.25-.57-.57l-2.07-2.07c.2-1.61-.96-2.54-.96-2.54,0-.02-.05-.17-.06-.19-.06-.16-.32-.95-.42-1.86,0,0,.08-.3.08-.64s-.06-.69-.06-.69Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m54.89,35.09l-.23-.22-.51-.51c-1.05-1.05-2.69-1.21-3.82-.37-.23.17-.43.36-.59.58,0,0,.26.11.49.27.29.21.47.42.47.42.1-.12.21-.23.34-.32,1.18-.88,2.37.34,2.37.34.49-.21.99-.25,1.49-.19Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m53.47,61.2c3.05,2.92,6.55,4.36,10.14,4.18.35-.02.67.09.89.31l1.31,1.31.84-.84-1.31-1.31c-.45-.45-1.1-.69-1.78-.66-3.16.16-6.26-1.09-9-3.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "m65.97,68.7c-.51-.51-.51-1.35,0-1.86l9.53-9.54c.51-.51,1.35-.51,1.85-.01l24.08,22.36-13.1,13.11-22.36-24.05Zm10.61-10.62c-.08-.08-.21-.08-.29,0l-9.53,9.54c-.08.08-.08.21.01.3l21.59,23.22,11.46-11.47-23.25-21.59Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m47.57,78.28c-13.61-1.99-24.31-12.65-26.49-26.08"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "25.03 55.76 21.17 52.79 18.2 56.65 17.82 53.75 20.79 49.89 24.65 52.86 25.03 55.76"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m83.42,51.1c-1.77,13.97-12.64,25-26.36,27.14"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "60.64 74.31 57.65 78.15 61.5 81.14 58.6 81.5 54.75 78.51 57.74 74.67 60.64 74.31"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m54.17,15.67c14.97.94,27,12.29,29.16,26.76"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "79.41 38.83 83.24 41.84 86.24 38.01 86.59 40.91 83.59 44.74 79.76 41.73 79.41 38.83"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m20.87,43.58c1.59-14.23,12.61-25.5,26.55-27.61"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-5",
    points: "43.82 19.89 46.82 16.06 42.99 13.06 45.89 12.7 49.72 15.7 46.72 19.54 43.82 19.89"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkelpCommInv);
export default __webpack_public_path__ + "static/media/SKELP_CommInv.0b6b1e28c63cc114c0a8eed0f1a01846.svg";
export { ForwardRef as ReactComponent };